
























































































































































import { Component, Prop } from 'nuxt-property-decorator'
import { ComponentVue } from '@/base'
import { SimpleBibliographyReal } from '@/api'
import { IconBibliography } from '@/components/molecules/IconBibliography'
import {
  BibliographyDetailRealTabType,
  BibliographyDetailSetTabType,
  CollectionFlag,
  Prefix
} from '@/types'
@Component({
  components: { IconBibliography }
})
export default class BibliographyRealInfoSimple extends ComponentVue {
  @Prop({
    type: Object,
    required: true
  })
  input!: SimpleBibliographyReal

  @Prop({
    type: Boolean,
    default: false
  })
  titleLink!: boolean

  get displayBibliographyId() {
    if (this.input.bibliographyId < 1) {
      return ''
    }
    return (
      this.input.prefix + this.input.bibliographyId.toString().padStart(10, '0')
    )
  }

  get displayBibliographySetId() {
    if (this.input.bibliographySetId === null) {
      return ''
    }
    return (
      Prefix.Set + this.input.bibliographySetId.toString().padStart(10, '0')
    )
  }

  isCollectionFlagCollection(collectionFlag: CollectionFlag): boolean {
    return collectionFlag === CollectionFlag.Collection
  }

  // ここから資料照会ダイアログ
  openModalBibliographyDetail(bibliographyRealId: number) {
    this.openModalBibliographyDetailReal(
      bibliographyRealId,
      BibliographyDetailRealTabType.Collection
    )
  }

  openModalBibliographyDetailReal(
    bibliographyRealId: number,
    tabType: BibliographyDetailRealTabType,
    bibliographyContentId?: number
  ) {
    this.$modalBibliographyDetailReal.open({
      bibliographyRealId,
      isBibliographySelectProcess: false,
      tabType,
      bibliographyContentId,
      onToggleSet: (
        bibliographyId: number,
        tabType: BibliographyDetailRealTabType
      ) => {
        this.openModalBibliographyDetailSet(bibliographyId, tabType)
      }
    })
  }

  openModalBibliographyDetailSet(
    bibliographySetId: number,
    tabType: BibliographyDetailSetTabType
  ) {
    this.$modalBibliographyDetailSet.open({
      bibliographySetId,
      isBibliographySelectProcess: false,
      tabType,
      onToggleReal: (
        bibliographyId: number,
        tabType: BibliographyDetailRealTabType
      ) => {
        this.openModalBibliographyDetailReal(bibliographyId, tabType)
      }
    })
  }

  // ここまで資料照会
}
